module.exports = __webpack_public_path__ + "media/Momentum_KnokDoorbell_InstallationVideo_Final_Step10-11.fd3b5fa3.mp4";